export const theme = {
  fontFamily: 'Graphik, Roboto, sans-serif',
  palette: {
    primary1Color: 'var(--primary-color)',
    primary2Color: 'var(--accent-color)',
    accent1Color: 'var(--accent-color)',
    pickerHeaderColor: 'var(--primary-color)',
    textColor: 'var(--text-color)',
    secondaryTextColor: 'var(--text-light)',
    canvasColor: 'var(--list-color)'
  },
  icon: {
    color: 'var(--text-color)'
  },
  inkBar: {
    backgroundColor: 'var(--icon-color)',
  },
  listItem: {
    leftIconColor: 'var(--icon-color)',
    rightIconColor: 'var(--icon-color)'
  },
  snackbar: {
    textColor: 'var(--list-color)'
  },
  subheader: {
    color: 'var(--text-color)'
  },
  tabs: {
    backgroundColor: 'var(--list-color)'
  },
  textField: {
    floatingLabelColor: 'var(--label-color)'
  },
  toggle: {
    thumbOnColor: 'var(--accent-color)',
    trackOnColor: 'var(--accent-dark)'
  }
};



// WEBPACK FOOTER //
// ./src/helpers/theme.js